import accountInfo from './accountInfo';
import common from './common';
import dictionary from './dictionary';
import notice from './notice';
import score from './score';
export default {
  accountInfo,
  common,
  dictionary,
  notice,
  score,
}